import { requestAnimationFrame } from 'CommonUtils/raf.js';
import { localSaveRaw, localLoadRaw, sessionSave, sessionLoad } from '../../storageService';
import { logMessage } from '../../js/common/logger';
import { content } from './chat-content-assistant';
import { fetchAndStream, answer_time } from './stream';

const env = window.readcookie(ENV_COOKIE) || API_ENV;
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const errorCode = urlParams.get('error_code') && decodeURIComponent(urlParams.get('error_code')) || '';
let lang = languageAttributes.languageCode;
lang = languageAttributes.languageCode === 'hi' && languageAttributes.spokenLanguageCode === 'en' ? 'en' : lang;
const iframe_elem = document.getElementById('iframe-ai') ;
const is_iframe = iframe_elem ? true : false;

let stream_lang_code;

switch (languageAttributes.languageCode) {
    case 'es':
        stream_lang_code = 'lm';
        break;
        case 'ar':
        stream_lang_code = 'arab';
        break;

    default:
        stream_lang_code = 'hi-en2';
        break;
}

let isMob = window.innerWidth < 768 && "ontouchstart" in document.documentElement ? true : false;

const hp_question = localLoadRaw('iforexai-hpq') || '';

let chat_exp = localLoadRaw(`chatAi_exp_${lang}`);
let chatAi_countQ = localLoadRaw(`chatAi_countQ_${lang}`);
let threadId = localLoadRaw(`chatAi_threadId_${lang}`) || '';


let chatContainer = document.getElementById('chat-ai');
let loader = document.getElementById('ai-loader');
let aiInput = document.getElementById("ai-question-input");
let aiIputWrapper = document.getElementById("ai-input-wrapper");
let main_banner = document.querySelector(".main-banner");
let main_header = document.getElementById("main-header");
let submitButton = document.getElementById("ai-submit");
let ChatList = document.getElementById("all-messages");
let cookie_notif = document.getElementById("cookie-notif");
let popup_questions = document.getElementById('ai-chat-popup-questions');

let try_again = document.getElementById('ai-tryAgain');
let please_wait = document.getElementById('ai-pending-answer');
const ai_chat_popup_body = document.querySelector('.ai-chat-popup-body');

let aiInputVal = hp_question || '';
let count_questions = 0;
count_questions = chatAi_countQ ? chatAi_countQ * 1 : 0;

let typing_active = false;

const hi_en_website = languageAttributes.languageCode === 'hi' && languageAttributes.spokenLanguageCode === 'en';

let aiContent = hi_en_website ? content.en : content[languageAttributes.languageCode];

let aiLandCode = lang;

let hi_hi = false;

export let live_agent_msg = aiContent.agent;


let errorsObj =
{
    400: aiContent.error_msg_400,
    408: aiContent.error_msg_408,
    general: aiContent.error_msg
}

let errorText = errorsObj.general;



function fadeIn(element, duration) {
    element.style.opacity = 0;
    let startTime = null;

    function animate(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, 0, 1, duration);
        element.style.opacity = run;

        if (timeElapsed < duration) {
            requestAnimationFrame(animate);
        }
    }

    function ease(t, b, c, d) {
        t /= d;
        return -c * t * (t - 2) + b;
    };

    requestAnimationFrame(animate);
}


function setMessage(type, text) {

    let message_class = type == 'question' ? 'user' : 'ai';
    let li = document.createElement('li');

    li.classList.add(message_class);
    type === 'stopChat' && li.classList.add('limit');
    li.innerHTML = type === 'stopChat' ?
        `<p id="stopChat">
                                <p class="name"></p>
                                <p class="limit-text">${aiContent.thank_you_msg}</p>
                            </p>` :
        !text ? `
                                <p class="typing"><span></span><span></span><span></span></p>
                                <p class="text pending-answer"></p>` :
                                `<p class="name"></p>
                                <div class="text">${text}</div>`;

    requestAnimationFrame(() => {
        ChatList.appendChild(li);
        if (!typing_active || type == 'question') {
            fadeIn(li, 1000);
        }

    });
}


export function getDate() {
    const now = new Date();

    const options = {
        timeZone: 'GMT',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    };

    const formattedDate = now.toLocaleString('en-US', options).split(',')[0];
    const formattedTime = now.toLocaleString('en-US', options).split(',')[1].trim();

    return `${formattedDate} ${formattedTime}`;
}


function setLogMessage(response, q_date, a_date, cta_clicked) {

    let details = response ? response.details : '';

    if (response.output) {

        logMessage({
            eid: 'AIPrompt',
            chat_id: threadId,
            chat_question: aiInputVal,
            chat_question_date: q_date,
            chat_answer: response.output.replace(/<br\s*\/?>/gi, ' '),
            chat_answer_date: a_date,
            chat_device_type: isMob ? 'mobile' : 'desktop',
            ai_response: JSON.stringify(response),
            chat_q_count: count_questions * 1,
            lang: hi_hi ? 'hi' : aiLandCode,
            chat_cta_clicked: cta_clicked || false
        })

    } else {
        logMessage({
            eid: 'AI_Error',
            chat_question: aiInputVal,
            chat_id: threadId,
            chat_error_code: details ? details.httpStatus : 'no error details',
            chat_error_message: details ? details.error : 'no error details',
            chat_date_time: getDate(),
            chat_device_type: isMob ? 'mobile' : 'desktop',
            ai_response: JSON.stringify(response),
            chat_q_count: count_questions * 1 + 1,
            lang: hi_hi ? 'hi' : aiLandCode

        })
    }
}

function setLogBlocked(eid, text) {
    logMessage({
        eid: eid,
        chat_id: threadId,
        chat_error_code: 0,
        chat_question: text,
        chat_date_time: getDate(),
        chat_device_type: isMob ? 'mobile' : 'desktop',
        chat_q_count: count_questions * 1,
        lang: hi_hi ? 'hi' : aiLandCode
    })
}

function disableInput() {
    aiInput.placeholder = "";
    aiInput.disabled = true;
    aiInput.value = '';
    submitButton.classList.add('disabled');
    popup_questions.classList.add('disable');
    aiIputWrapper.classList.add('disabled');
    chatContainer.classList.add('disabled');

}

function enableInput() {
    aiInput.placeholder = aiContent.placeholder;
    aiInput.disabled = false;
    popup_questions.classList.remove('disable');
    submitButton.classList.remove('disabled');
    aiIputWrapper.classList.remove('disabled');
    aiInput.focus();
    chatContainer.classList.remove('disabled');

}

function stopChat(type) {

    disableInput();
    if (type !== 'error') {
        setMessage('stopChat');
        let now = new Date();
        let expiryTime = chat_exp || now.getTime() + 12 * 60 * 60 * 1000; // 12 hours in ms
        localSaveRaw(`chatAi_exp_${lang}`, expiryTime)
    }


}

function sessionSaveChat(type, text) {
    let chat_history = sessionLoad(`chatAi_chat_history_${lang}`) || {};
    let count = Object.keys(chat_history).length + 1;
    chat_history[`${type}_${count}`] = text;
    sessionSave(`chatAi_chat_history_${lang}`, chat_history);
}

export function scrollToChatBodyBottom() {
    if (ai_chat_popup_body) {
        ai_chat_popup_body.scrollTo({
            top: ai_chat_popup_body.scrollHeight + 50,
            behavior: 'smooth' // enables smooth animation
        });
    }
}

function setQuestion(q) {

    let question = q ? q : aiInputVal;

    disableInput();
    setMessage('question', question);
    setMessage('answer');
    scrollToChatBodyBottom()
    

}

export function isRelativeUrl(url) {
  return !/^(?:[a-z][a-z0-9+.-]*:)?\/\//i.test(url);
}

function setQuestions() {
        document.querySelectorAll('.ai-question:not(.withClickEvent)').forEach((q) => {
            q.onclick = function () {
                
                let dataQ = q.dataset.question;
                aiInputVal = dataQ;
                let q_id = q.id;

                if(['ai_q1','ai_q2','ai_q3'].includes(q_id)){
                    
                    setQuestion();
                    
                    setTimeout(() => {
                        
                        let answer = aiContent[q_id];
                        let answer_following_questions = aiContent[`${q_id}_btns`];

                        let pending_elem = document.querySelector('.pending-answer');
                        pending_elem && pending_elem.classList.remove('pending-answer');

                        document.querySelectorAll('.typing').forEach((el) => {
                            el.style.display = 'none';
                        });

                        count_questions++;
                        
                        for (let index = 0; index < answer.length; index++) {
                            setTimeout(() => {
                                pending_elem.innerHTML += answer[index];
                                 scrollToChatBodyBottom();
                                 if(index === answer.length -1 ){
                                    if( count_questions >= 50){
                                            stopChat();
                                            setLogBlocked('AIChatLocked', question);
                                    }else{
                                        pending_elem.innerHTML = answer;
                                         pending_elem.innerHTML += answer_following_questions;
                                         setQuestions();
                                         scrollToChatBodyBottom();
                                        enableInput();
                                    } 
                                 }
                           }, 30 * index);
                           
                        }
                        
                        localSaveRaw(`chatAi_countQ_${lang}`, count_questions);
                        
                        sessionSaveChat('q', dataQ);
                        sessionSaveChat('a', count_questions >= 50 ? answer  : answer +  answer_following_questions);
                         
                        logMessage({
                            eid: 'ai-fixed-question',
                            chat_id: threadId,
                            chat_question: dataQ,
                            chat_device_type: isMob ? 'mobile' : 'desktop',
                            chat_q_count: count_questions * 1,
                            lang: hi_hi ? 'hi' : aiLandCode
                        })

                    }, 1500)

                }   else{
                    submitInput(dataQ, false, true);
                }

            };

            q.classList.add('withClickEvent');
        });
    }


function setAnswer(text, response_error, questions) {

    response_error ? disableInput() : enableInput();

    let t = text.replace(/【\d+:\d+†[^】]+】/g, '')
        .replace(/<br\s*\/?>\s*(?=<li>)/g, '')
        .replace(/<\/li>\s*<br\s*\/?>/g, '</li>')
        .replace(/<ul>\s*<br\s*\/?>/g, '<ul>')
        .replace(/<br\s*\/?>\s*<\/ul>/g, '</ul>')
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        .replace(/\n/g, '<br>');

    let pending_elem = document.querySelector('.pending-answer');
    let typing = document.querySelector('.typing');
    //let error_elem = document.querySelector('#ai-chat-error');
    // error_elem.innerHTML = t ;
    
    //if(response_error && pending_elem){ pending_elem.innerHTML = `<span id='ai-chat-error'>${t}</span>`; }

    const hasLinkPattern = /\[([^\]]+)\]\(([^)]+)\)/;

        if (hasLinkPattern.test(t)) {
        
            const linkPattern = /\[([^\]]+)\]\(([^)]+)\)/g;

            const out = t.replace(linkPattern, (m, label, url) => {
                const cleanUrl = url.trim();
                const pageName = cleanUrl.replace(/.*\/([^/?#]+).*$/, "$1");
                const text = (label && label.trim()) || pageName || cleanUrl;

                return cleanUrl.startsWith("http")
                ? `<a href="${cleanUrl}" target="_blank" rel="noopener">${text}</a>`
                : `<a href="${cleanUrl}">${text}</a>`;
            });


            pending_elem.innerHTML = out;
            t = out;
        }

        if(pending_elem){
            pending_elem.innerHTML = response_error ? `<span id='ai-chat-error'>${t}</span>` : t.replace(/\n/g, "<br/>");
            pending_elem.classList.remove('pending-answer');
        }
    

    if (typing) { typing.style.display = 'none'; }

    if (questions && questions.length > 0) {
        questions.forEach((q) => {

            
            if(is_iframe){
                let btn = q.type === 'question' 
                ? `<span class="ai-following-question ai-question" data-question="${q.label}">${q.label}</span>` : 
                q.type === 'cta' && !q.url.includes('register') ? 
                `<a href="#" 
                    data-label="${encodeURIComponent(q.label)}"
                    data-url="${encodeURIComponent(q.url)}"
                    class="ai-cta"
                    onclick="
                        window.redirectToLink(
                            decodeURIComponent(this.dataset.label), 
                            decodeURIComponent(this.dataset.url), 
                            true
                        )
                    ">
                    ${q.label}
                    </a>` : '';
                if(pending_elem) {pending_elem.innerHTML += btn;}
                t += btn;

            }else{
                let btn = q.type === 'question' ? `<span class="ai-following-question ai-question" data-question="${q.label}">${q.label}</span>` : q.type === 'cta' ? `<a href="#" onclick="window.redirectToLink('${ q.label}','${ q.url}')"  class="ai-cta">${q.label}</a>` : '';
                if(pending_elem) {pending_elem.innerHTML += btn;}
                t += btn;
            }
           
           
           
        });
       
    }

    setQuestions();
    scrollToChatBodyBottom();
    !response_error && sessionSaveChat('a', t);

}


    window.redirectToLink = function( label, url,iframe){
        
        logMessage({
                eid: 'ai-btn-link-clicked',
                chat_id: threadId,
                chat_device_type: isMob ? 'mobile' : 'desktop',
                chat_q_count: count_questions * 1,
                lang: hi_hi ? 'hi' : aiLandCode,
                label : label,
                url : url
            })

        let link = isRelativeUrl(url) && !url.includes("/hi") && lang === 'hi'  ? '/hi'+url :  url ;

        setTimeout(() => {
            
         is_iframe ? window.open(link, "_blank", "noopener noreferrer") : isRelativeUrl(url) ? window.open(link, "_self") : window.open(link, "_blank", "noopener");

        }, 1200); 




    }


let refresh_btn_clicks = 0;
let question_reserved = '';
let ai_refresh_btn = document.getElementById('ai_refresh_btn');

ai_refresh_btn && ai_refresh_btn.addEventListener('click', (e) => {

    setLogMessage('ai-refresh-btn', getDate(), answer_time);

    try_again.style.display = 'none';
    refresh_btn_clicks++;

    for (let i = 0; i < 2; i++) {
        if (ChatList.lastElementChild) {
            ChatList.removeChild(ChatList.lastElementChild);
        }
    }

    submitInput(question_reserved, false,false);

})

export async function submitInput(q, dontSetQ, cta_clicked) {

    let question = q ? q : aiInputVal.trim();
    question_reserved = question;
    let question_time = getDate();
    let response_error = false;

    if (question !== "") {
        !dontSetQ && setQuestion();
        let answer;

         try {
            answer = await fetchAndStream(question, stream_lang_code, threadId);
            
         } catch (error) {
            console.log(error)
         }

        setTimeout(() => {
            if (!answer) {
                please_wait.style.display = 'block';
                scrollToChatBodyBottom();
            }
        }, 9000);

        setTimeout(() => {
            if (!answer) {
                if (refresh_btn_clicks < 2) {
                    please_wait.style.display = 'none';
                    try_again.style.display = 'block';
                    let typing = document.querySelector('.typing');
                    if (typing) { typing.style.display = 'none'; }
                    
                } else {
                    please_wait.style.display = 'none';
                    setAnswer(errorText, true);
                }

                scrollToChatBodyBottom();

                //setLogMessage('no server response timeout')
            }
        }, 15000);

        if (answer) {
          

              if(answer.includes('No thread found')) {
                console.log('No thread found');
                threadId = '';
                 submitInput(q,true, cta_clicked);
                 return false;
            }else{

                const regex = /(\{.*?\})(?=\{|\s*$)/g;

                try {

                // Match and parse each JSON object
                const jsonObjects = answer.match(regex).map(obj => JSON.parse(obj));


                let run_info_chunck = jsonObjects.find(obj => obj.type === "runInfo");

                let jsonObj = run_info_chunck ? run_info_chunck.data : '';


                let output = jsonObj && jsonObj.output ? JSON.parse(jsonObj.output) : '';
                //let details = jsonObj ? jsonObj.details : '';
                 console.log(output, 'output');
                

                let live_agent = output && output.action && output.action === 'Live-agent';

                if (threadId.length === 0) {
                    threadId = jsonObj && jsonObj.threadId ? jsonObj.threadId : '';
                    localSaveRaw(`chatAi_threadId_${lang}`, threadId)
                }


                let questions = output && output.q ? output.q : false;

                response_error = !output ? true : false;

                !response_error && count_questions++;

                setLogMessage(jsonObj ? jsonObj : answer, question_time, answer_time, cta_clicked);

                let text = live_agent ? aiContent.agent : output ? output.html : errorText;

                !response_error && sessionSaveChat('q', question);

                setAnswer(text, response_error, count_questions < 50 ? questions : '');

                localSaveRaw(`chatAi_countQ_${lang}`, count_questions);

                (response_error || count_questions >= 50) && stopChat(response_error ? 'error' : '');

                count_questions >= 50 && setLogBlocked('AIChatLocked', question);
                } catch (error) {
                    console.log('Error parsing JSON:', error);
                    setAnswer(errorText, true);
                    stopChat('error');
                }
            }
        }
    }
}

function checkInputA() {

    aiInputVal = aiInput.value;
    aiInputVal.trim() !== "" ? submitButton.classList.remove('disabled') : submitButton.classList.add('disabled');

}


function checkIfChatBlocked() {
    let now = new Date();
    if (now.getTime() > chat_exp) {
        count_questions = 0;
        try {
            localStorage.removeItem('chatAi_exp');
            localStorage.removeItem('chatAi_countQ');
        } catch (error) {

        }

        hp_question ? submitInput() : enableInput();
    } else {
        setLogBlocked('AIChatLocked', aiInputVal);
            setMessage('stopChat');
        setTimeout(() => {
            
            scrollToChatBodyBottom();
        }, "100");
        disableInput();
    }
}

window.onload = function () {

    if (errorCode !== '') {
        // add error_code param to url to test errors
        errorText = (errorCode in errorsObj) ? errorsObj[errorCode] : errorText;

        setAnswer(errorText, true);

        logMessage({
            eid: 'AI_Error_test',
            chat_question: aiInputVal,
            chat_id: threadId,
            chat_error_id: errorCode,
            chat_error_message: errorsObj[errorCode],
            chat_date_time: getDate(),
            chat_device_type: isMob ? 'mobile' : 'desktop',
            chat_q_count: count_questions * 1,
            lang: hi_hi ? 'hi' : aiLandCode

        })

    }




    if (chatContainer) { chatContainer.style.display = 'block'; }
    if (loader) { loader.style.display = 'none'; }


    submitButton && submitButton.addEventListener("click", () => {
        aiInput.value.trim() !== "" && submitInput();
    });

    if (aiInput) {
        aiInput.addEventListener("input", checkInputA);

        aiInput.addEventListener('keydown', (event) => {
            event.key === 'Enter' && aiInput.value.trim() !== "" && submitInput();
        });
    }



    count_questions >= 50 || chat_exp ? checkIfChatBlocked() : hp_question ? submitInput() : '';

    if (hp_question) {

        try {
            localStorage.removeItem("iforexai-hpq");
        } catch (error) {
            console.log(error)
        }

    }


    


    //isMob && stickyInput();



    setQuestions();

}

